export const trimSlashes = (text: string) => {
    // Trim slashes at start and end of string
    return text.replace(/^\/+|\/+$/g, '');
};

const path = trimSlashes(window.location.pathname);

export const setLocalStorageItem = (key: string, value: any, ttl?: number) => {
    const item = {
        value,
        expires: ttl ? Date.now() + ttl : null,
    };

    localStorage.setItem(path + '.' + key, JSON.stringify(item));
};

export const getLocalStorageItem = (key: string) => {
    const item = localStorage.getItem(path + '.' + key);
    if (!item) return null;
    const itemParsed = JSON.parse(item);
    if (itemParsed.expires && Date.now() > itemParsed.expires) {
        // If the item is expired, delete it from storage
        localStorage.removeItem(path + '.' + key);
        return null;
    }

    return itemParsed.value;
};
